import React from "react";
import API from "@unisearch/helpers/api";
import { LayoutMain } from "@unisearch/theme/layout";
import ConsultantsInBangalore from "@modules/consultants/consultants_In_bangalore";
import { getAssets } from "@unisearch/helpers";

const ConsultantsInBangalorePage = ({ pageData }) => {
  return (
    <LayoutMain
      contactInfo={{
        phone: "080-49779636",
        email: "info.bangalore@myunisearch.com",
      }}
      title="Study Abroad Consultants in Bangalore"
      metaTitle="Study Abroad Consultants in Bangalore"
      metaImage={getAssets(
        "assets/images/consultant/unisearch-bangalore-meta.png"
      )}
      metaDescription="Planning to study abroad but confused about how to get going? That’s where UniSearch - the best overseas education consultants in Bangalore - comes in. Our goal at UniSearch is simple - we strive to make the right study abroad solution available for every student, at every stage of their journey. UniSearch Bangalore’s study abroad consultants have helped thousands of students like you to secure admissions and visa applications for their dream universities. With over 20 years of experience, they help you discover your ideal program and universities from across the six popular destinations: Australia, Canada, Ireland, New Zealand, the UK, and the USA. Whether you’re visiting us in person at our Bangalore branch, or connecting with us remotely through our virtual office, our overseas education consultants commit to making your study abroad journey as smooth as possible."
      metaKeywords="UniSearch, study abroad, education, consultants, Bangalore’s study, virtual office, overseas, visa counselling, language test training"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/study-abroad-consultants-in-bangalore`}
    >
      <ConsultantsInBangalore pageData={pageData} />
    </LayoutMain>
  );
};

export default ConsultantsInBangalorePage;

export async function getServerSideProps() {
  let props = {
    pageData: "",
  };
  try {
    await API.get(
      "public/lead-contact-form/pages/study-abroad-consultants-in-bangalore"
    ).then((resp) => {
      if (resp && resp?.data && !resp.error && resp.statusCode != 500) {
        props.pageData = resp?.data;
      }
    });
    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
